import { Box, CircularProgress, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface NoteProps {
    readonly id: string;
    readonly testId: string;
    readonly tone?: string;
    readonly detail?: string;
}

export function Note({
    id,
    testId,
    tone = 'text.secondary',
    detail,
}: NoteProps) {
    return (
        <Typography fontSize={11} color={tone} data-testid={testId}>
            <FormattedMessage id={id} />
            {detail ? ` ${detail}` : ''}
        </Typography>
    );
}

export function Progress({ id, testId }: { id: string; testId: string }) {
    return (
        <Box display="flex" alignItems="center" gap={1} data-testid={testId}>
            <CircularProgress size={12} />
            <Typography fontSize={11} color="text.secondary">
                <FormattedMessage id={id} />
            </Typography>
        </Box>
    );
}
